<script lang="ts">
</script>

<div class="flex flex-col w-full justify-center gap-[calc(10vh-2vw)]">
  <slot />
</div>
